import React from 'react';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import SearchBar from 'components/UI/V3/SearchBar/SearchBar';
import { DateRangeOption } from 'components/UI/V3/DateRangePickerDropdown';
import { SelectDropdownOption } from 'components/UI/V3/SelectDropdown/SelectDropdown';
import styles from './Reviews.module.scss';
import { MetricBox } from 'components/UI/V3/MetricBox/MetricBox';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import ReviewsSearchActions from './ReviewsSearchActions';

type Rating = 1 | 2 | 3 | 4 | 5;

interface ReviewsHeaderProps {
    searchText: string;
    onChangeSearchText: (text: string) => void;
    dateRange: DateRangeOption['value'];
    onChangeDateRange: (value: DateRangeOption['value']) => void;
    timeZone: string;
    // Ratings filter (multi)
    ratings: Array<SelectDropdownOption<Rating>>;
    onChangeRatings: (values: Array<SelectDropdownOption<Rating>>) => void;
    // Metrics
    avgRating: number;
    totalReviews: number;
    positiveCount: number;
    negativeCount: number;
    onSetupReviews?: () => void;
}

const ReviewsHeader: React.FC<ReviewsHeaderProps> = ({
    searchText,
    onChangeSearchText,
    dateRange,
    onChangeDateRange,
    timeZone,
    ratings,
    onChangeRatings,
    avgRating,
    totalReviews,
    positiveCount,
    negativeCount,
    onSetupReviews
}) => {
    const MetricBoxTitle = ({ title, tooltip }: { title: string; tooltip: string }) => (
        <div className={styles.metricBoxTitleContainer}>
            <h3 className={styles.metricBoxTitle}>{title}</h3>
            <Tooltip
                content={tooltip}
                className={styles.tooltipContent}
            >
                <div className={styles.tooltipIcon}>
                    <span>i</span>
                </div>
            </Tooltip>
        </div>
    );
    return (
        <div className={styles.container}>
            <div className={styles.headWrapper}>
                <DefaultHeader
                    title="Reviews"
                    displayButton
                    buttonLabel="Setup Reviews"
                    onClick={onSetupReviews}
                    leftContentClassName={styles.headerLeftOffset}
                />
                <p className={styles.description}>Overview of all sales for a specific time period.</p>

                <div className={styles.metricsRow}>
                    <MetricBox
                        title="Avg. Rating"
                        value={<span>{avgRating.toFixed(1)} ★</span>}
                        className={styles.metricBox}
                    />
                    <MetricBox
                        title="Total Reviews"
                        value={totalReviews}
                        className={styles.metricBox}
                    />
                    <MetricBox
                        title={
                            <MetricBoxTitle
                                title="Positive"
                                tooltip="Set feeding times for each part of the day in Business Settings."
                            />
                        }
                        value={positiveCount}
                        className={styles.metricBox}
                    />
                    <MetricBox
                        title={
                            <MetricBoxTitle
                                title="Negative"
                                tooltip="Set feeding times for each part of the day in Business Settings."
                            />
                        }
                        value={negativeCount}
                        className={styles.metricBox}
                    />
                </div>

                <div>
                    <SearchBar
                        placeholder="Search by client"
                        searchText={searchText}
                        onChangeSearchText={onChangeSearchText}
                        rightActions={
                            <ReviewsSearchActions
                                timeZone={timeZone}
                                dateRange={dateRange}
                                onChangeDateRange={onChangeDateRange}
                                ratings={ratings}
                                onChangeRatings={onChangeRatings}
                            />
                        }
                    />
                </div>
            </div>
        </div>
    );
};

export default ReviewsHeader;
